// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"d0f5435c","590":"b7d8f9ad","655":"f2b24730"}[chunkId] + ".chunk.js";
};